import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function iosBuildDeleteApi(payload: RequestDataShape, token: string) {
	const endpoint = "/ios/build/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
